import { useApi } from 'hb-builder/api';
import type { Category } from 'hb-react/backoffice/components/CategoriesList/v2/types';
import { POSTS_CATEGORIES_QUERY_KEY } from 'hb-react/backoffice/constants/builder/builderApiKeys';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosWithSyntaxHandlers } from 'hb-react/shared/utils/axios';

export const useGetPostCategories = ({ enabled }) => {
  const { authenticationIds } = useApi();

  const postsQueryFn = async (): Promise<Category[]> => {
    const { data } = await axiosWithSyntaxHandlers.get(
      Routes.categories_backoffice_network_dynamic_components_search_index_path(
        authenticationIds.network,
        {
          categorized_type: 'Posts::FeedPost',
          format: 'json',
        },
      ),
      { params: authenticationIds },
    );

    return data;
  };

  return useQueryOnce([POSTS_CATEGORIES_QUERY_KEY], postsQueryFn, {
    enabled,
  });
};
